import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
import { useWorkspaceStore } from '@/store/workspace.store';

/**
 * Wrapper de conveniencia sobre el auth store con la lógica de redirect.
 * Las páginas usan `login`/`logout` desde aquí para navegar tras la acción.
 */
export function useAuth() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const status = useAuthStore((s) => s.status);
  const error = useAuthStore((s) => s.error);
  const accessToken = useAuthStore((s) => s.accessToken);

  const loginAction = useAuthStore((s) => s.login);
  const logoutAction = useAuthStore((s) => s.logout);

  const login = async (email: string, password: string, redirectTo = '/') => {
    await loginAction(email, password);
    navigate(redirectTo, { replace: true });
  };

  const logout = async () => {
    await logoutAction();
    // El negocio activo es parte de la sesión: si entra otro usuario en este
    // navegador, no puede heredar el negocio del anterior.
    useWorkspaceStore.getState().clear();
    navigate('/login', { replace: true });
  };

  return {
    user,
    status,
    error,
    isAuthenticated: Boolean(accessToken && user),
    isLoading: status === 'loading',
    login,
    logout,
  };
}
